import React from 'react'
import PropTypes from 'prop-types'

const NO_AUTOCORRECT = {
    autoComplete: 'off',
    autoCorrect: 'off',
    spellCheck: 'false',
}


const Input = ({
    onChange,
    name,
    object,
    validation,
    placeholder,
    className = '',
    type = 'text',
    onBlur = () => {
    },
    onEnter,
    autoCapitalize = 'words',
    autoCorrect = false,
    readOnly = false,
    isMoney = false,
    max = null,
    min = null,
    step = null,
    pattern = '.*',
    filterValue = (value) => value,
}) => {
    className = validation && validation[name] ? 'form-control error ' + className : 'form-control ' + className
    const autoCorrectAttributes = autoCorrect ? {} : NO_AUTOCORRECT

    let value = isMoney && object[name] ? (object[name]/100).toString().replace('.', ',') : object[name]

    if (value === 0) {
        value = '0'
    }
    return (
        <input
            className={className}
            type={type}
            placeholder={placeholder}
            value={value || ''}
            name={name}
            onBlur={onBlur}
            {...autoCorrectAttributes}
            autoCapitalize={autoCapitalize}
            onKeyPress={(event) => {
                if (onEnter && event.key === 'Enter') {
                    onEnter()
                }
            }}
            max={max}
            min={min}
            step={step}
            pattern={pattern}
            readOnly={readOnly}
            onChange={event => {
                if (readOnly) {
                    return
                }

                if (isMoney) {
                    const value = event.target.value ? parseFloat(event.target.value) * 100 : null
                    onChange(name, value)
                    return
                }

                if (filterValue) {
                    event.target.value = filterValue(event.target.value);
                }

                onChange(name, event.target.value)
            }}/>
    )
}

Input.propTypes = {
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired,
    object: PropTypes.object.isRequired,
    validation: PropTypes.object,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    type: PropTypes.string,
    onBlur: PropTypes.func,
    autoCapitalize: PropTypes.string,
    autoCorrect: PropTypes.bool,
    isMoney: PropTypes.bool,
    max: PropTypes.number,
    pattern: PropTypes.string,
}


export default Input



// WEBPACK FOOTER //
// ./src/modules/form/component/Input.js